export default {
  SKIP_INTRO: 'skip-intro',
  WATCH_CREDITS: 'watch-credits',
  NEXT_EPISODE: 'next-episode',
};
